import TermsModal from "./modals/TermsModal";
import GamesSaga from "./saga";
import Games from "./reducer";

import { registerModals } from "modals";
import { registerRoutings } from "rootRouting";
import store from "rootStore";
import { IConfig, permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const url = "/tickets";
export const chooseActivityUrl = "/choose-activity";
export const activitiesUrl = "/activities";
export const groupBookingUrl = "/group-booking";
export const bookTableUrl = "/book-table";
export const basketUrl = "/basket";
export const checkoutUrl = "/checkout";
export const liveUrl = "/live";
export const thankYouUrl = "/thank-you";
export const failedUrl = "/failed";

export const uuid = window.location.pathname.match(
    /\/tickets\/([A-Za-z0-9-]+)/
)?.[1];

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        permissions: {
            create: true,
            delete: true,
            read: true,
            update: true,
        },
        routing: [],
        url,
    };

    let routing: routingType = [];
    registerModals({
        TermsModal,
    });
    store.injectSaga?.("GamesSaga", GamesSaga);
    store.reducerManager?.add("Games", Games);

    const isGroupBookingPage = settings.show_contact_form;
    routing.push(
        {
            path: `/`,
            element: <AsyncComponent path="Games/pages/GamesIndexPage" />,
        },
        {
            path: chooseActivityUrl,
            element: (
                <AsyncComponent path="Games/pages/GamesChooseActivitiesPage" />
            ),
        },
        {
            path: activitiesUrl,
            element: <AsyncComponent path="Games/pages/GamesActivitiesPage" />,
        },
        {
            path: bookTableUrl,
            element: <AsyncComponent path="Games/pages/GamesBookTablePage" />,
        },
        {
            path: basketUrl,
            element: <AsyncComponent path="Games/pages/GamesBasketPage" />,
        },
        // {
        //     path: checkoutUrl,
        //     element: <AsyncComponent path="Games/pages/GamesCheckoutPage" />,
        // },
        {
            path: liveUrl,
            element: <AsyncComponent path="Games/pages/GamesLivePage" />,
        },
        {
            path: thankYouUrl,
            element: <AsyncComponent path="Games/pages/GamesThankYouPage" />,
        },
        {
            path: failedUrl,
            element: <AsyncComponent path="Games/pages/GamesFailedPage" />,
        }
    );
    if (isGroupBookingPage) {
        routing.push({
            path: groupBookingUrl,
            element: (
                <AsyncComponent path="Games/pages/GamesGroupBookingPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
